<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    xml:space="preserve"
    fill="currentColor"
    class="icon icon--carret-down"
  >
    <path
      d="M17,9.2c-0.2-0.2-0.4-0.3-0.7-0.3S15.8,9,15.6,9.2L12,12.7L8.5,9.2C8.3,9,8,8.9,7.8,8.9
	C7.5,8.9,7.2,9,7.1,9.2C7,9.3,6.9,9.4,6.8,9.5C6.8,9.6,6.8,9.7,6.8,9.9c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3l4.2,4.2
	c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0.1,0.3,0.1,0.4,0.1s0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2l4.3-4.2c0.1-0.1,0.2-0.2,0.2-0.3
	c0.1-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.3-0.1-0.4C17.2,9.4,17.1,9.3,17,9.2z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconCarretDown',
}
</script>
